import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FgaIconName, GROUP_ICON } from './fga-icon.model';
import { ENTITY_TYPE } from '../../models/entity.model';

@Component({
  selector: 'fga-icon',
  imports: [CommonModule],
  templateUrl: './fga-icon.component.html',
  styleUrls: ['./fga-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FgaIconComponent {
  readonly name = input<FgaIconName>(ENTITY_TYPE.USER);
  readonly size = input<number>(16);
  readonly ariaLabel = input<string | null>(null);
  readonly title = input<string | null>(null);

  // Derived state
  readonly isDecorative = computed(() => !this.ariaLabel());

  // AngularKit mapping: FGA name -> AngularKit icon class
  readonly ngKitIconClass = computed(() => {
    switch (this.name()) {
      case ENTITY_TYPE.GROUP:
        return 'ds-ngkit-users';
      case GROUP_ICON.LOCAL:
        return 'ds-ngkit-user-groups';
      case GROUP_ICON.SCIM:
        return 'ds-ngkit-manage-group-permissions';
      case ENTITY_TYPE.M2M:
        return 'ds-ngkit-server';
      case ENTITY_TYPE.USER:
      default:
        return 'ds-ngkit-user';
    }
  });

  // Final classes to apply
  readonly hostClasses = computed(() => [
    'fga-icon',
    'ds-ngkit',
    this.ngKitIconClass(),
  ]);
}